import { notification } from 'antd';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useState } from 'react';
import WidgetModel, {
  EmailConfig,
  WidgetBase,
} from '@mm/state/model/WidgetModel';

export const useEmailTemplatesLandings = ({
  widget,
  onDeleteRemote,
}: {
  widget: WidgetModel;
  onDeleteRemote?: (url) => void;
}) => {
  const {
    config: { entities },
  } = widget as unknown as WidgetBase<EmailConfig>;

  const masterLanding = entities?.find(entity => entity.master);
  const widgetLandings =
    entities
      ?.map(entity => entity.url)
      .filter(url => url !== masterLanding?.url) || [];

  const sortedLandings = masterLanding
    ? [masterLanding?.url, ...widgetLandings]
    : widgetLandings;

  const [selectedLandings, setSelectedLandings] = useState<string[]>(
    sortedLandings || [],
  );
  const { openDeleteConfirmModal } = useModalActions();

  const onDelete = url => {
    onDeleteRemote?.(url);
    setSelectedLandings(prev => prev.filter(item => item !== url));
    notification.success({ message: 'Deleted', placement: 'topLeft' });
  };

  const onChangeSelectedLandings = (url: string) => {
    if (selectedLandings.includes(url)) {
      openDeleteConfirmModal({
        headerText: 'Are you sure you want to delete this email template?',
        deleteCallback: () => onDelete(url),
        newStyle: true,
      });
    } else {
      setSelectedLandings([...selectedLandings, url]);
    }
  };

  return {
    selectedLandings,
    onChangeSelectedLandings,
  };
};
